import { computed as r, defineAsyncComponent as o, createBlock as d, openBlock as p, resolveDynamicComponent as f, normalizeProps as u, guardReactiveProps as m, withCtx as s, renderSlot as c } from "vue";
import { themeProp as y } from "../../composables/useTheme.js";
import { screenProp as v } from "../../utils/utilsScreen.js";
import g from "../../utils/validators/link.js";
import B from "../../utils/validators/video.js";
import h from "../../utils/validators/image.js";
import C from "../../utils/validators/orientation.js";
const w = /* @__PURE__ */ Object.assign({
  name: "DsMediaTextBlock"
}, {
  __name: "media-text-block",
  props: {
    ...y,
    ...v,
    contained: {
      type: Boolean,
      default: !1
    },
    orientation: {
      type: String,
      default: "right",
      validator: (e) => C(e)
    },
    fullWidthContent: {
      type: Boolean,
      default: !1
    },
    fullWidthMedia: {
      type: Boolean,
      default: !1
    },
    fullHeightMedia: {
      type: Boolean,
      default: !1
    },
    centerAligned: {
      type: Boolean,
      default: !1
    },
    /**
     * Image, optional
     * @property {Object} image.small - { src: String, name: String }
     * @property {Object} image.medium - { src: String, name: String }
     * @property {Object} image.large - { src: String, name: String }
     */
    image: {
      type: Object,
      default: null,
      validator: (e) => h(e)
    },
    aspectRatio: {
      type: String,
      default: null
    },
    /**
     * Video, optional
     * @property {String} title
     * @property {Object} thumbnail - { small: { src: String, name: String }, medium, large }
     * @property {Object} sizes - { small: { width: Number, height: Number }, medium, large }
     * @property {String} extension
     * @property {Boolean} selfHosted
     * @property {String} src
     */
    video: {
      type: Object,
      default: null,
      validator: (e) => B(e)
    },
    videoAutoplay: {
      type: Boolean,
      default: !1
    },
    eyebrow: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    /**
     * Link
     * @property {string} link.title - link title
     * @property {string} link.url - link href value
     * @property {boolean} link.openInNewWindow - open the link in a new window
     * @property {boolean} link.nuxt - renders as nuxt link
     */
    link: {
      type: Object,
      default: null,
      validator: (e) => g(e)
    },
    withShadow: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, l = r(() => a.contained ? i : n), n = o(() => import("./components/media-text-component.vue.js")), i = o(
      () => import("./components/media-text-contained-component.vue.js")
    );
    return (t, S) => (p(), d(f(l.value), u(m(t.$props)), {
      default: s(() => [
        c(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  w as default
};
